// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"567":"5bbd3f22","818":"c6f9f908","833":"f9aed19c","955":"99395d60","991":"968849f4"}[chunkId] + ".chunk.js";
};